import script from "./MailCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./MailCompose.vue?vue&type=script&setup=true&lang=js"

import "./MailCompose.vue?vue&type=style&index=0&id=fcbd9db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcbd9db6"]])

export default __exports__